import React, { useState, useEffect } from 'react'
import { useParams,useNavigate } from 'react-router-dom';
import { MainDataQuestion } from '../ui/MainDataQuestion';
import { TailSpin } from "react-loader-spinner";
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../actions/auth';
import { Navbar } from '../ui/NavBar';
import {encode as base64_encode} from 'base-64';
import  { GetCourseChild }  from '../../controllers/GetCourseChild';
import  { ProgressInsert }  from '../../controllers/ProgressInsert';
import  { GetCourseInfo }  from '../../controllers/GetCourseInfo';
import  { PositionUpdate }  from '../../controllers/PositionUpdate';
import  { positionByCourse }  from '../../controllers/positionByCourse';
// Home to display "Lecciones"
export const ChildScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const [imgCourse, setImgCourse] = useState("");
    const [imgType, setImgType] = useState("");
    const [nameUnit, setNameUnit] = useState("");
    const { fatherId } = useParams();
    const { unitId } = useParams();
    const cursoId = localStorage.getItem('courseId');
    const cursoColor = localStorage.getItem('courseColor');
    localStorage.setItem('childFather',fatherId);
    const [course, setCourse] = useState([]);
    const [cursoNombre, setCursoNombre] = useState('');
    let user = useSelector( state => state.auth );
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);

    let ran = false;
    useEffect(() => {
        if (ran) return;
            
            GetCourseChild(cursoId, user.languaje, token, user.id, fatherId)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                const duplicates = e.reduce((acc, current) => {
                    const existingElement = acc.find(item => item.id === current.id);
                    
                    if (!existingElement) {
                      acc.push(current);
                    }
                  
                    return acc;
                  }, []);
                let found = duplicates.find(element => element.id === parseInt(unitId));
                //console.log(found)
                if(found?.image_value !== undefined && found?.image_value !== null){
                    setImgCourse(found.image_value)
                    setImgType(found.image_value_type)
                }
                

                if(found?.progress_id === null ){
                    ProgressInsert(token, user.id, found.id )
                    .catch((e)=>{
                        console.error(e);
                        // dispatch(logout(token));
                    });
                }
                if(found?.text_value !== null  && found?.text_value !== undefined){
                    setNameUnit(found.text_value)
                }
                setLoading(false)
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
            let posN = 0;
            let posUrl = '';
            positionByCourse( token, user.id, cursoId)
            .then((e)=>{
                posN = e[0].id;
                posUrl = e[0].url;
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
        
            GetCourseChild(cursoId, user.languaje, token, user.id, unitId)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                const duplicates = e.reduce((acc, current) => {
                    const existingElement = acc.find(item => item.id === current.id);
                    
                    if (!existingElement) {
                      acc.push(current);
                    }
                  
                    return acc;
                  }, []);
                setList(duplicates);
                let found = duplicates.find(element => element?.ending_id === null);
                // console.log({found})
                if(found){
                    if(posN !== 0){
                        PositionUpdate( token, user.id, cursoId, `/child/${ fatherId }/${ unitId }`, posN)
                        .catch((e)=>{
                            console.error(e);
                            // dispatch(logout(token));
                        });
                    }
                }
                else{
                    if(posUrl === `/child/${ fatherId }/${ unitId }`){
                        PositionUpdate( token, user.id, cursoId,`/course/${ cursoId }`, posN)
                        .catch((e)=>{
                            console.error(e);
                            // dispatch(logout(token));
                        });
                    }

                }
                
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });

            GetCourseInfo(cursoId, user.languaje, token, user.id)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                setCourse(e[0]);
                if(e[0]?.name){
                    setCursoNombre(e[0].name)
                }
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });

        return () => (ran = true);
    }, [cursoId,unitId])

  
    // if(course.length===0){
    //     history( '/home', {
    //         replace: true
    //     });
    // }

    const disCourse = ()=>{
        let lists = list;
        lists.sort((a, b) => a.id - b.id);
        // let count = lists.find((course) => {
        //     if(course.ending_id!==null){
        //         return course
        //     }       
        // });
        let count = [];
        for (let i = 0; i < lists.length; i++) {
            if (lists[i].ending_id!==null) {
                count = list[i]
            }
          }
         let countp = lists[0];
        if(count?.id){
            //let listC = 0;
            countp = lists.find((course) => {
                //if(course.id>count.id && listC===0){
                if(course.id>count.id){
                    return course;
                    //listC++;
                }       
            });
        }

        if(!countp){
            for (let i = 0; i < lists.length; i++) {
                if (lists[i].ending_id === null) {
                    count = list[i]
                    break;
                }
              }
            if(count?.id){
                countp = lists.find((course) => {
                    if(course.id===count.id){
                        return course;
                    }       
                });
            }
            else{
                countp = lists[0];
            }
        }

        return lists.map((course) => (
            (course.ending_id!==null)?
                    <MainDataQuestion 
                    key={course.id}
                    fatherid={unitId}
                    id={course.id}
                    count_id={0}
                    name={course.text_value}
                    status_approved=''
                    url = {(course.course_level_children !== null )?`/gchild`:
                            (course.content_numbers !== null )?`/information`:
                            (course.question_numbers !== null )?"/question":'#'}
                    />:
                    <MainDataQuestion 
                    key={course.id}
                    fatherid={unitId}
                    id={course.id}
                    count_id={(countp.id===course.id)?0:course.id}
                    // count_id={(course.progress_id==null)?0:course.id}
                    //count_id={(course.ending_id!==null)?0:(course.progress_id!==null)?0:course.id}
                    name={course.text_value}
                    status_approved={(countp.id===course.id)?'pendiente':''}
                    
                    url = {(countp.id!==course.id)?'#':(course.course_level_children !== null )?`/gchild`:
                            (course.content_numbers !== null )?`/information`:
                            (course.question_numbers !== null )?"/question":'#'}
                    />
 
                )
        );
        
    }
    
    return (
        <div className="fund-main-unit">
            <Navbar title={cursoNombre}/>
            <div className="text-title"
            style={{
                backgroundColor: cursoColor,
                color:  "#ffffff",
            }}
            >{nameUnit && nameUnit}</div>
            
                {
                    course && (course.background_home_type==="svg")
                    ?
                    <img className="fund-start-b-imgu" src = {`data:image/svg+xml;base64,${base64_encode(course.background_home)}`} alt="Back Ground"/>
                    :
                    (course.background_home_type!==null) ? 
                    <img className="fund-start-b-imgu" src = {`data:image/${course.background_home_type}+xml;base64,${btoa(course.background_home)}`} alt="Back Ground"/>
                    :null
                }
            
            <div className="fund-main-lesson">
                <div className="content-lessons" >
                {loading && <div className="loader-page"><TailSpin
                    color="#00BFFF"
                    height={200}
                    width={200}
                />
                </div>}     
                {imgCourse && 
                    (imgType==='svg')?
                    <div className="circular--landscape">
                        <img className="img-unit1" src = {`data:image/svg+xml;base64,${base64_encode(imgCourse)}`} alt={nameUnit}/>
                    </div>
                    :(imgType!==null)?
                    <div className="circular--landscape">
                     <img className="img-unit1" src = {`data:image/${imgType}+xml;base64,${btoa(imgCourse)}`} alt={nameUnit}/>
                    </div>
                    :null
                }
 
                <div className="container-ulc">
                    {list && disCourse() }
                </div>
                
                </div>

            </div>
        </div>
    )
}

